var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconBUserCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsserif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "iconB-user-circle",
    x: 0,
    y: 0,
    width: 24,
    height: 24,
    style: {
      fill: "none"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "iconB-user-circle1",
    serifid: "iconB-user-circle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "iconB-user-circle2",
    serifid: "iconB-user-circle",
    d: "M19.42,20.112c-0.002,0.001 -0.003,0.003 -0.004,0.004c-0.023,0.02 -0.134,0.12 -0.135,0.12c-1.937,1.72 -4.487,2.764 -7.281,2.764c-2.799,-0 -5.353,-1.048 -7.28,-2.763c-0.001,-0.001 -0.149,-0.133 -0.149,-0.133c-2.192,-2.01 -3.567,-4.898 -3.567,-8.108c-0,-6.073 4.923,-10.996 10.996,-10.996c6.073,-0 10.996,4.927 10.996,11c0,3.206 -1.375,6.099 -3.576,8.112Zm-10.574,-8.941c0.002,1.741 1.413,3.153 3.154,3.155c1.742,-0 3.154,-1.413 3.154,-3.155c0,-1.742 -1.412,-3.154 -3.154,-3.154c-1.742,-0 -3.154,1.412 -3.154,3.154Zm-2.22,8.025c1.498,1.123 3.358,1.789 5.374,1.789c2.024,-0 3.892,-0.671 5.375,-1.79c-1.167,-1.722 -3.139,-2.854 -5.375,-2.854c-2.227,-0 -4.191,1.122 -5.374,2.855Zm-1.483,-1.398c0.866,-1.184 2.034,-2.136 3.434,-2.757c-1.071,-0.947 -1.747,-2.332 -1.747,-3.874c0,-2.855 2.315,-5.17 5.17,-5.17c2.855,0 5.17,2.315 5.17,5.17c-0,1.537 -0.671,2.917 -1.745,3.871c1.365,0.6 2.542,1.551 3.43,2.761c1.326,-1.565 2.126,-3.591 2.126,-5.803c0,-4.96 -4.021,-8.981 -8.981,-8.981c-4.96,0 -8.981,4.021 -8.981,8.981c0,2.211 0.802,4.249 2.124,5.802Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBUserCircle);
export default __webpack_public_path__ + "static/media/iconB-user-circle.f229236fa3a8712c508d7d464f54000e.svg";
export { ForwardRef as ReactComponent };